<template lang="pug">
  div
    // HEADER
    v-layout
      v-flex(lg2)
        rating-frame(:rating="job.rating")
      v-spacer
      v-flex(lg6)
        // ROW 1.1: ID, NAME, EDIT BUTTON
        v-layout(justify-center class="display-1")
          span {{ job.name }}
        v-layout(align-center
                 justify-space-between
                 class="title")
          v-flex(shrink)
            v-layout(align-baseline)
              span {{ job.id | formatJId }}
          v-btn(:disabled="job.id === 0"
                class="ma-0"
                flat
                icon
                @click="dialog = true")
            v-icon edit
        // ROW 1.2: RELATED ISSUE, APPOINTED FRANCHISE
        v-layout(v-if="job.id > 0"
                 align-center
                 justify-space-between
                 class="subtitle")
          v-flex(shrink)
            div(v-if="job.issue" class="mb-2")
              span Assigned to&nbsp;
              router-link(:to="{ name: 'issue', params: { id: job.issue.id } }"
                          class="clickable") {{ job.issue.id | formatIId }}
              span &nbsp;(
              router-link(:to="{ name: 'site', params: { id: job.issue.site } }"
                          class="clickable") {{ job.issue.site }}
              span )
          v-flex(v-if="job.franchise" shrink)
            div(v-if="job.franchise.id" class="mb-2")
              router-link(
                :to="{ name: 'franchise', params: { id: job.franchise.id } }"
                class="clickable") {{ job.franchise.name }}
              span &nbsp;was appointed.
          v-flex(v-else shrink)
            div(class="mb-2 red--text text--lighten-3")
              span No franchise appointed!
        v-divider(class="mb-5")
        v-layout
          v-flex
            costs(v-if="job.id > 0"
                  :costs="job.costs"
                  :job-id="job.id"
                  :sub-id="job.franchise ? job.franchise.subcontractorId : null"
                  :total-cost="job.totalCost"
                  @refresh="refreshCosts")
        v-layout
          v-flex
            comments
      v-spacer
      // TIMELINE
      v-flex(lg2)
        timeline(v-if="job.id > 0"
                 :expected-completion="job.expectedCompletion"
                 :timeline="job.timeline"
                 :statuses="jobStatuses"
                 @activateStatus="(id, iso) => activateStatus(id, iso)"
                 @updateStatusEvent="(id, iso) => updateStatusEvent(id, iso)"
                 @editExpCompDate="(iso) => updateExpCompletion(iso)")
    // EDIT DIALOG
    edit-dialog(v-model="dialog" :job="job")

</template>

<script>
import moment from "moment";

import Comments from "./Job/Comments.vue";
import Costs from "./Job/Costs.vue";
import EditDialog from "./Job/EditDialog.vue";
import RatingFrame from "./SharedComponents/RatingFrame.vue";
import Timeline from "./Job/Timeline.vue";

export default {
  components: {
    Comments,
    Costs,
    EditDialog,
    RatingFrame,
    Timeline
  },
  data () {
    return {
      // Boolean to toggle the edit dialog
      dialog: false,
      // The job under review
      job: {
        franchise: null,
        id: 0,
        name: "< Name >",
        rating: null
      },
      // Buffered job object while editing
      jobStatuses: []
    };
  },
  created () {
    // Get information on the job
    const { id } = this.$route.params;
    this.$http.
      get(`/api/jobs/${id}`).
      then((r) => this.job = Object.assign({}, r.data));
    // Get the job statuses
    this.$http.
      get("/api/job_statuses").
      then((r) => this.jobStatuses = Array.from(r.data));
  },
  methods: {
    activateStatus (id, iso) {
      this.$http.
        post("/api/job_status_events", {
          jobId: this.job.id,
          jobStatusId: id,
          date: moment(iso).local().format("YYYY-MM-DDTHH:mm:ss")
        }).
        then(() => {
          const { id } = this.$route.params;
          this.$http.
            get(`/api/jobs/${id}`).
            then((r) => Object.assign(this.job, r.data));
        });
    },
    refreshCosts () {
      const { id } = this.$route.params;
      this.$http.
        get(`/api/jobs/${id}`).
        then((r) => this.job = Object.assign({}, r.data));
    },
    updateExpCompletion (iso) {
      return this.$http.
        put(
          `/api/jobs/${this.job.id}`,
          {
            expectedCompletion: iso
              ? moment(iso).
                local().
                format("YYYY-MM-DDTHH:mm:ss")
              : null
          }
        ).
        then(() => this.$http.get(`/api/jobs/${this.job.id}`)).
        then((r) => {
          Object.assign(this.job, r.data);
          this.dialog = false;
        });
    },
    updateStatusEvent (id, iso) {
      this.$http.
        put(
          `/api/job_status_events?jobId=${this.job.id}&jobStatusId=${id}`,
          { date: moment(iso).local().format("YYYY-MM-DDTHH:mm:ss") }
        ).
        then(() => {
          const { id } = this.$route.params;
          this.$http.
            get(`/api/jobs/${id}`).
            then((r) => Object.assign(this.job, r.data));
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Job.vue